<template>
  <!-- LINE AREA CHART -->
  <div class="vx-col w-full my-base hidden lg:inline-block">
    <vx-card collapseAction title="نمودار درآمد شما" >
      <vue-apex-charts type="area" height="350" ref="Chart" v-if="lineAreaChartSpline.series[0].data" :options="lineAreaChartSpline.chartOptions" :series="lineAreaChartSpline.series"></vue-apex-charts>
    </vx-card>
  </div>

</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import axios from "../../../axios";

export default {
  name: 'chart',
  components: {
    VueApexCharts
  },
  methods:{
    getDataChart(){
      const self = this
      var arrayData = [];
      axios.post('/referrals/data-chart')
        .then(function (response) {
          Object.keys(response.data).map(function(key, index) {
            //self.lineAreaChartSpline.series[0].data.push(parseInt(response.data[index].sum));
            //self.lineAreaChartSpline.chartOptions.xaxis.categories.push(response.data[index].date);
            const obj = {};
            obj['x'] = (response.data[index].date)
            obj['y'] = parseInt(response.data[index].sum)
            arrayData.push(obj)

          });
          self.$refs.Chart.updateSeries([{
            data: arrayData
          }], false, true);

        }).catch(function (error) { console.log(error); })
    }
  },
  created() {
    this.getDataChart();
  },
  data () {
    return {
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
      lineAreaChartSpline: {

        series: [
          {
            name: 'درآمد',
            data: []
          }
        ],
        chartOptions: {
          chart: {
            fontFamily: 'iranyekan, Helvetica, Arial, sans-serif',
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },
          colors:  ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
          xaxis: {
            categories: ["19 دی 1399", "18 دی 1399"],
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return value.toLocaleString('en-US');
              }
            },
          },
          tooltip: {
            enabled: true,
            fillSeriesColor: true,
            style: {
              fontSize: '12px',
              fontFamily: 'vazir'
            },
            theme: 'dark',
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .apexcharts-text tspan{
    letter-spacing:normal;
  }
</style>
